export const PORTAL_SCREENS = [
    {
        key: "portal-home",
        labelKey: "portal.nav.home",
        module: "portal",
        capability: "portal.plans.view",
        icon: "home",
        landed: true,
        primary: true,
    },
    {
        key: "portal-plans",
        labelKey: "portal.nav.plans",
        module: "portal",
        capability: "portal.plans.view",
        icon: "calendar",
        landed: true,
        primary: true,
    },
    {
        key: "portal-notifications",
        labelKey: "portal.nav.notifications",
        module: "notifications",
        capability: "notifications.view_own",
        icon: "bell",
        landed: true,
        /**
         * **وخرجت من الشريط إلى جرس الرأس** — بموك أب البورتال المعتمَد (شادي ٢٠٢٦-١١-٠٢):
         * الشريطُ الرئيسية · الخطط · المحادثة · المزيد، **والجرسُ بنقطته فوق كلّ شاشة**.
         */
    },
    /**
     * **«اللي عليك» للعميل** (قرار شادي ٢٠٢٦-١٠-١٩) — ونفسُ سطح الموظّف.
     *
     * **وقراراتُه قراراتٌ كذلك**: عنصرٌ ينتظر موافقته، وموعدٌ ينتظر ردَّه. **وهو
     * بعينه ما يقلّل «العميل مش بيردّ»** — لا يُطلَب منه أن يتذكّر، بل يفتح شاشةً
     * فيها ما عليه.
     *
     * **وخارج الشريط السفلي** — فحدُّه خمسةٌ وهو مكتملٌ، **والقرارُ أيُّها يُطوى
     * لا أن يُضاف سادسٌ يضيق**. ويصله الإشعارُ على كل حال، ورابطُه يفتح صفَّه.
     */
    {
        key: "portal-actions",
        labelKey: "portal.nav.actions",
        module: "notifications",
        capability: "actions.view_own",
        icon: "check",
        landed: true,
    },
    {
        key: "portal-contacts",
        labelKey: "portal.nav.contacts",
        module: "portal",
        capability: "portal.contacts.view",
        icon: "users",
        landed: true,
        /**
         * **وخرجت من الشريط السفلي حين نزل جدولُ النشر** — فالحدُّ خمسة.
         *
         * والقاعدةُ مكتوبةٌ هنا منذ المرحلة التاسعة: «**ولو زاد لاحقاً فالقرارُ
         * أيُّها يُطوى لا أن يُضاف سادسٌ يضيق**» — فكسرتُها بنفسي حين أضفتُ
         * السادس، وأمسكتها دعوى «خمسةٌ بالضبط».
         *
         * **وهذه هي التي تُطوى**: «زملائي» يُفتَح مرّةً ليُعرَف من في الفريق، أمّا
         * بيتُه وخطّتُه وجدولُ نشره وتنبيهاتُه فأسئلةُ كلِّ يوم. وتبقى شاشةً كاملةً
         * في «المزيد» — **خروجٌ من شريطٍ لا حذفٌ من نظام**.
         */
    },
    // ═══════════ المؤجَّلة — كلٌّ بموديولها، وبوابةٌ تُلزم بالعودة ═══════════
    /**
     * **جدولُ النشر وإثباتُه** — مع الوساطة في المرحلة السابعة.
     *
     * وهي أوّلُ ما ستكسره البوابة: يومَ تُسجَّل أوّلُ قدرةٍ في موديول `publishing`
     * ولم تنزل هذه الشاشة، **يقع البناء**.
     */
    {
        key: "portal-schedule",
        labelKey: "portal.nav.schedule",
        /**
         * **واسمُه `moderation` لا `publishing`.**
         *
         * وكان `publishing` — **وموديولٌ بهذا الاسم لا وجود له**، فما طابق اسمَ
         * موديولٍ حيٍّ يوماً. فنزلت المرحلةُ السابعة كاملةً **وبوّابةُ «موديولٌ حيٌّ
         * وشاشتُه البورتالية غائبة» خضراءُ وهي تحرس اسماً وهمياً** — والعميلُ بلا
         * جدولِ نشرٍ يراه.
         */
        module: "moderation",
        capability: "portal.schedule.view",
        icon: "calendar",
        landed: true,
        /** **وتحت «المزيد»** — بموك أب البورتال المعتمَد؛ والرئيسيةُ تقول ما قرب نشرُه */
    },
    {
        key: "portal-chat",
        labelKey: "portal.nav.chat",
        module: "chat",
        /**
         * **وقدرتُها هي قدرةُ الكتابة** — فمن يكتب للوكالة يقرأ جوابَها.
         *
         * وقدرةٌ ثانيةٌ للقراءة كانت ستعني حالةً ثالثة — **يقرأ ولا يردّ** — لا
         * يحتاجها أحد: خيطٌ يُقرأ ولا يُكتَب فيه هو إشعارٌ لا محادثة.
         */
        capability: "portal.chat.send",
        icon: "message",
        landed: true,
        /**
         * **وفي الشريط السفلي** (قرار شادي ٢٠٢٦-١٠-١٩) — فكلامُه معنا يوميّ.
         *
         * **وخمسةٌ حدُّ الشريط، فالقرارُ أيُّها يُطوى**: فطُويت التقاريرُ — يقرؤها
         * مرّةً في الشهر **ويصلها من إشعارها** يومَ ينشر تقريرُه، أمّا المحادثةُ
         * فيفتحها ليسأل. وبندٌ يُضاف سادساً يضيق على الخمسة كلِّها.
         */
        primary: true,
    },
    {
        key: "portal-meetings",
        labelKey: "portal.nav.meetings",
        module: "meetings",
        /** **وقدرةٌ واحدةٌ لطرفه كلِّه** — يطلب، ويبتّ في اقتراحنا */
        capability: "portal.meetings.request",
        icon: "calendar",
        landed: true,
    },
    {
        key: "portal-reports",
        labelKey: "portal.nav.reports",
        module: "reports",
        /**
         * **ويقرؤها صاحبُها بقدرة رؤية خطّته.**
         *
         * فالتقريرُ عن شغلِ شهرٍ في خطّته، **ومن يرى الخطة يرى تقريرَها**. وقدرةٌ
         * ثانيةٌ لنفس السطح كانت ستعني حالةً ثالثة — يرى الخطةَ ولا يرى تقريرَها —
         * لا يحتاجها أحد.
         */
        capability: "portal.plans.view",
        icon: "chart",
        landed: true,
        /**
         * **وخارج الشريط** (قرار شادي ٢٠٢٦-١٠-١٩) — ويبقى شاشةً في «المزيد».
         *
         * **فالتقريرُ يُقرأ مرّةً في الشهر، والمحادثةُ تُفتَح كلَّ يوم**. ويصل
         * العميلَ **من إشعاره** يومَ يُنشَر تقريرُه، ورابطُ الإشعار يفتح صفَّه —
         * فلا يحتاج بنداً دائماً ليجده.
         *
         * وهذا هو تطبيقُ القاعدة لا استثناءٌ عليها: **خمسةٌ حدُّ الشريط، والقرارُ
         * أيُّها يُطوى لا أن يُضاف سادسٌ يضيق**.
         */
    },
    {
        key: "portal-profile",
        labelKey: "portal.nav.profile",
        module: "portal_profile",
        capability: null,
        icon: "user",
        landed: false,
        phase: "مع تغليف البيع",
    },
];
/** ما نزل فعلاً — تُبنى منه قائمةُ البورتال، فلا بندَ لشاشةٍ غائبة */
export const LANDED_PORTAL_SCREENS = PORTAL_SCREENS.filter((screen) => screen.landed);
/** ما لم ينزل — تقرؤه البوابة، ويقرؤه من يسأل «ماذا بقي؟» */
export const DEFERRED_PORTAL_SCREENS = PORTAL_SCREENS.filter((screen) => !screen.landed);
//# sourceMappingURL=screens.js.map